"use client";

import dynamic from "next/dynamic";
import type { ComponentType } from "react";

// Props types for lazy components
interface MobileMenuProps {
  user: boolean;
  userInfo: any;
  countries: any;
  error: any;
  userId?: string;
}

interface NavbarActionsProps {
  user: boolean;
  userId?: string;
  userInfo: any;
  userError: any;
  countries: any;
  error: any;
}

// Lazy load components that use Supabase client to reduce initial bundle
// These are loaded only on client-side after hydration
export const LazyMobileMenu: ComponentType<MobileMenuProps> = dynamic(
  () => import("./MobileMenu.js") as any,
  {
    ssr: false,
    loading: () => null,
  }
);

export const LazyNavbarActions: ComponentType<NavbarActionsProps> = dynamic(
  () => import("./NavbarActions.js") as any,
  {
    ssr: false,
    loading: () => (
      <div className="text-sm flex items-center space-x-2">
        <div className="w-24 h-10 bg-gray-200 rounded animate-pulse" />
        <div className="w-24 h-10 bg-gray-200 rounded animate-pulse" />
      </div>
    ),
  }
);
